import React from 'react';
import ImagePlaceholder from './ImagePlaceholder';
import useFadeIn from './useFadeIn';

const features = [
  {
    icon: '⚡',
    title: 'Mocny silnik',
    desc: 'V6 3.5L – płynne przyspieszenie i prestiżowy dźwięk',
  },
  {
    icon: '⚙️',
    title: 'Automatyczna skrzynia',
    desc: 'Płynna i komfortowa jazda bez szarpnięć',
  },
  {
    icon: '🪑',
    title: 'Jasne skórzane wnętrze',
    desc: 'Tapicerka w jasnych odcieniach – idealna na sesje zdjęciowe',
  },
  {
    icon: '❄️',
    title: 'Klimatyzacja',
    desc: 'Pełna kontrola temperatury — zawsze komfortowo',
  },
  {
    icon: '👥',
    title: 'Komfort dla 5 osób',
    desc: 'Przestronna kabina z miejscem dla całej świty',
  },
  {
    icon: '📸',
    title: 'Idealny do zdjęć',
    desc: 'Efektowna sylwetka, która wygląda doskonale w każdym ujęciu',
  },
];

export default function About() {
  const leftRef = useFadeIn();
  const rightRef = useFadeIn();

  return (
    <section
      id="about"
      style={{
        padding: '120px 24px',
        background: 'linear-gradient(180deg, #050a1a 0%, #0a1628 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative glow */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.07) 0%, transparent 70%)',
          left: -200,
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: 80,
            alignItems: 'start',
          }}
        >
          {/* Left column */}
          <div ref={leftRef} className="fade-in-section">
            <p className="section-label" style={{ marginBottom: 16 }}>O samochodzie</p>
            <h2 className="section-title" style={{ marginBottom: 24 }}>
              Infiniti FX35 –{' '}
              <span
                style={{
                  fontStyle: 'italic',
                  background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                elegancja
              </span>{' '}
              i moc w jednym
            </h2>

            <p
              style={{
                fontSize: 15,
                lineHeight: 1.8,
                color: 'rgba(244,245,247,0.6)',
                marginBottom: 40,
                maxWidth: 480,
              }}
            >
              Infiniti FX35 to luksusowy SUV łączący sportową dynamikę z wyrafinowaną elegancją.
              Jego charakterystyczna sylwetka przykuwa wzrok, a jasne skórzane wnętrze tworzy
              wyjątkowy klimat — idealny na ślub i sesje zdjęciowe. Każdy przejazd to
              niezapomniane doświadczenie dla Pary Młodej i świty.
            </p>

            {/* Feature cards grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: 12,
              }}
            >
              {features.map((f) => (
                <FeatureCard key={f.title} {...f} />
              ))}
            </div>
          </div>

          {/* Right column – images */}
          <div ref={rightRef} className="fade-in-section" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/*
              PODMIEŃ ZDJĘCIE:
              Umieść about-main.jpg w /public/images/
              <img src="/images/about-main.jpg" alt="Infiniti FX35 – widok boczny" style={{ width:'100%', borderRadius:16 }} />
            */}
            <div
              style={{
                borderRadius: 16,
                overflow: 'hidden',
                boxShadow: '0 24px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(59,130,246,0.08)',
              }}
            >
              <ImagePlaceholder label="Infiniti FX35 – widok boczny&#10;(about-main.jpg)" aspectRatio="16/10" />
            </div>

            {/* Mini gallery */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              {[
                { label: 'Przód&#10;(about-front.jpg)', ratio: '4/3' },
                { label: 'Wnętrze&#10;(about-interior.jpg)', ratio: '4/3' },
                { label: 'Detale&#10;(about-detail.jpg)', ratio: '4/3' },
              ].map((img, i) => (
                <div
                  key={i}
                  style={{
                    borderRadius: 10,
                    overflow: 'hidden',
                    border: '1px solid rgba(59,130,246,0.1)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(59,130,246,0.4)';
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(59,130,246,0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <ImagePlaceholder label={img.label} aspectRatio={img.ratio} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div
      className="glass-card"
      style={{
        padding: '20px 18px',
        transition: 'all 0.3s ease',
        cursor: 'default',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.35)';
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(59,130,246,0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.15)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{ fontSize: 22, marginBottom: 10 }}>{icon}</div>
      <h3 style={{ fontSize: 13, fontWeight: 600, color: '#f4f5f7', marginBottom: 6, letterSpacing: '0.02em' }}>
        {title}
      </h3>
      <p style={{ fontSize: 12, color: 'rgba(244,245,247,0.5)', lineHeight: 1.6 }}>{desc}</p>
    </div>
  );
}
